<script lang="ts">
const __DsBlock = {
	name: '$t:blocks.calendar.name',
	icon: 'lucide:calendar',
	category: 'layout',
	type: 'listing-layout',
	hidden: true,
	events: [
		{
			name: 'open',
			payload: [
				{
					name: 'value',
					type: 'object',
					array: false,
					required: true,
				},
			],
		},
		{
			name: 'update:displayOptions',
			payload: [
				{
					name: 'value',
					type: 'object',
					array: false,
					required: true,
				},
			],
		},
	],
}
</script>
<script lang="ts" setup>
import type { CompositePrimaryKey } from '#layers/data-model';
import type { CalendarDisplayOptions, SharedLayoutEmits, SharedLayoutProps } from '~/types/layout';
import { defineBlock } from '#layers/block-engine';

interface LayoutCalendarBlockProps extends SharedLayoutProps<CalendarDisplayOptions> {}

defineProps<LayoutCalendarBlockProps>();

defineEmits<Pick<SharedLayoutEmits, 'open' | 'update:displayOptions'>>();

const selection = defineModel<CompositePrimaryKey[]>('selection', { default: () => [] });

;
</script>

<template>
	<LayoutCalendar
		v-bind="$props"
		v-model:selection="selection"
		@open="$emit('open', $event)"
		@update:display-options="$emit('update:displayOptions', $event)"
	/>
</template>
